import styled from 'styled-components';

const ContentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 32px;

  @media (min-width: 321px) {
    padding: 24px;
  }
`;

export default ContentList;
